// extracted by mini-css-extract-plugin
module.exports = {"message":"index__message__3ygSw","title":"index__title__3FllA","text":"index__text__20fYs"};